/* eslint-disable import/order */
import React, { useState } from 'react'
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  makeStyles,
  withStyles,
} from '@material-ui/core'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import { Link as RouteLink, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import classNames from 'classnames'
import queryString from 'query-string'
import axios from 'axios'

import FormGroupLaundry from './FormGroupLaundry'
import FormGroupUser from './FormGroupUser'
import config from '../../../../config'
import styles from '../../../../resources/theme/auth'
import colors from '../../../../assets/colors'
import { SNACKBAR } from '../../../main/MainActions'

const useStyles = makeStyles(theme => ({
  page: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fafafa',
    padding: `${theme.spacing(4)}px ${theme.spacing(2)}px`,
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      alignItems: 'flex-start',
    },
  },
  card: {
    width: '100%',
    maxWidth: '1080px',
    maxHeight: `calc(100vh - ${theme.spacing(8)}px)`,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: '#FFF',
    borderRadius: '20px',
    boxShadow: '0px 10px 15px 0px #00000040',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      minHeight: '100vh',
      maxHeight: 'none',
      borderRadius: 0,
      boxShadow: 'none',
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: `${theme.spacing(3)}px`,
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px`,
    borderBottom: `1px solid ${colors.lightGray}`,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: `${theme.spacing(2)}px`,
      padding: `${theme.spacing(2)}px`,
    },
  },
  headerText: {
    minWidth: 0,
  },
  logoBox: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    borderRadius: '12px',
    background: 'linear-gradient(180deg, #FFFFFF 0%, #D9D9D9 100%)',
    [theme.breakpoints.down('xs')]: {
      order: -1,
      alignSelf: 'center',
    },
  },
  logo: {
    width: '130px',
    maxWidth: '100%',
  },
  title: {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '26px',
    color: colors.primary,
  },
  subtitle: {
    fontSize: '13px',
    lineHeight: '20px',
    color: colors.textPrimary,
    marginTop: '4px',
  },
  form: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  body: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(3)}px`,
    padding: `${theme.spacing(3)}px ${theme.spacing(4)}px`,
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: colors.graylight,
      borderRadius: '8px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: `${theme.spacing(3)}px ${theme.spacing(2)}px`,
      gap: `${theme.spacing(3)}px`,
    },
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: `${theme.spacing(3)}px`,
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px`,
    borderTop: `1px solid ${colors.lightGray}`,
    backgroundColor: '#FFF',
    [theme.breakpoints.down('xs')]: {
      padding: `${theme.spacing(2)}px`,
      gap: `${theme.spacing(2)}px`,
    },
  },
  routeLink: {
    fontSize: '13px',
    fontWeight: 500,
    color: colors.primary,
    textDecoration: 'none',
    transition: 'all .4s',
    '&:hover': {
      opacity: '.6',
    },
  },
  submit: {
    borderRadius: '15px',
    padding: '10px 32px',
    backgroundColor: colors.primary,
    color: '#FFF',
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: '14px',
    transition: 'all .4s',
    '&:hover': {
      backgroundColor: colors.primary,
      opacity: 0.6,
    },
    '&.Mui-disabled': {
      backgroundColor: colors.primary,
      color: '#FFF',
      opacity: 0.6,
    },
  },
  circular: {
    color: '#FFF',
  },
  success: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: `${theme.spacing(1)}px`,
    padding: `${theme.spacing(6)}px ${theme.spacing(4)}px`,
  },
  successIcon: {
    fontSize: '56px',
    color: colors.sucess,
    marginBottom: `${theme.spacing(1)}px`,
  },
}))

const SelfRegistration = props => {
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()

  const [sucess, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)

  const { classes: styleSheet } = props

  const handleFormSubmit = async e => {
    e.preventDefault()

    const form = e.currentTarget
    const data = new FormData(form)

    if (!data.get('uf')) {
      dispatch({
        type: SNACKBAR.HARDFAIL,
        error: { message: 'Selecione a UF do endereço.' },
      })
      return
    }

    if (loading) {
      return
    }

    setLoading(true)

    try {
      await axios.post(`${config.API_URL}/self-registration`, data)

      setSuccess(true)
      dispatch({
        type: SNACKBAR.SOFTSUCCESS,
        success: {
          message:
            'Sucesso! Seu teste foi iniciado, aguarde e será redirecionado.',
        },
      })

      setTimeout(() => {
        history.push({
          pathname: `/`,
          search: `?${queryString.stringify({
            email: data?.get('manager_email'),
          })}`,
        })
      }, 6000)
    } catch (e) {
      if (e.response?.data?.errors) {
        Object.values(e.response?.data?.errors).map(errors =>
          errors.map(e =>
            dispatch({
              type: SNACKBAR.HARDFAIL,
              error: {
                message: e,
              },
            })
          )
        )
      } else if (e.response?.status === 429) {
        dispatch({
          type: SNACKBAR.HARDFAIL,
          error: {
            message:
              'Muitas tentativas em sequência. Aguarde um minuto e tente novamente.',
          },
        })
      } else if (e.response?.data?.message) {
        dispatch({
          type: SNACKBAR.HARDFAIL,
          error: {
            message: e.response?.data?.message,
          },
        })
      } else {
        dispatch({
          type: SNACKBAR.HARDFAIL,
          error: {
            message: 'Não foi possível concluir o cadastro. Tente novamente.',
          },
        })
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box className={classes.page}>
      <Box
        className={classNames({
          [styleSheet.animationFade]: true,
          [classes.card]: true,
        })}
      >
        {sucess ? (
          <Box className={classes.success}>
            <CheckCircleOutlineIcon className={classes.successIcon} />
            <Typography className={classes.title}>
              Cadastro realizado!
            </Typography>
            <Typography className={classes.subtitle}>
              Seu teste foi iniciado. Você será redirecionado para a tela de
              login em alguns instantes.
            </Typography>
          </Box>
        ) : (
          <>
            <Box className={classes.header}>
              <Box className={classes.headerText}>
                <Typography className={classes.title}>
                  Criar minha conta
                </Typography>
                <Typography className={classes.subtitle}>
                  Preencha os dados da lavanderia e do gerente responsável para
                  iniciar o seu teste.
                </Typography>
              </Box>

              <Box className={classes.logoBox}>
                <img
                  className={classes.logo}
                  src="/img/logo.png"
                  alt="Logo Higsystem"
                />
              </Box>
            </Box>

            <form className={classes.form} onSubmit={handleFormSubmit}>
              <Box className={classes.body}>
                <FormGroupLaundry />

                <FormGroupUser />
              </Box>

              <Box className={classes.footer}>
                <RouteLink to="/" className={classes.routeLink}>
                  Voltar para tela de login
                </RouteLink>

                <Button
                  type="submit"
                  className={classes.submit}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={16} className={classes.circular} />
                  ) : (
                    'Enviar'
                  )}
                </Button>
              </Box>
            </form>
          </>
        )}
      </Box>
    </Box>
  )
}

export default withStyles(styles)(SelfRegistration)
